
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDockedProposal as ObiDockedProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-docked-proposal.js';
 
 
 

 
 export const ObiDockedProposal = createComponent({
   react: React,
   tagName: 'obi-docked-proposal',
   elementClass: ObiDockedProposalElement,
   events: {
     
   }
  });
 
 